import { TextStyle, View, ViewStyle } from "react-native";
import { StyleHelpers } from "../constants/style-helpers";
import { COLORS } from "../../config/colors";
import CText from "../../ui/components/CText";
import { isIOS } from "../helpers";
import { THEME_COLORS } from "../../theme/constants/themeColors";

type Props = {
  count: number | string;
  style?: ViewStyle;
  textStyle?: TextStyle,
};
export default function CountBadge(props: Props) {
  const {
    count = '',
    style = {},
    textStyle = {},
  } = props;

  return (
    <View
      style={{
        position: "absolute",
        backgroundColor: THEME_COLORS.primaryColor,
        minHeight: 15,
        minWidth: 18,
        padding: 2,
        right: -4,
        top: -2,
        borderRadius: 20,
        paddingHorizontal: 5,
        borderColor: COLORS.whiteColor,
        zIndex: 9,
        ...StyleHelpers.totalCenter,
        ...style,
      }}
    >
      <CText bold size={9} style={{
        color: COLORS.whiteColor,
        marginTop: isIOS() ? 2 : 0.5,
        // lineHeight: isIOS() ? 18 : 12,
        ...textStyle,
      }}>{count}</CText>
    </View>
  );
}
